export const ALLOWED_OVERBOOK_COUNT = 20;
export const DATE_RANGE_KEY_SEPARATOR = '|';
export const MIN_RATE_SUFFIX = 'min';
export const MAX_RATE_SUFFIX = 'max';
export const SUMMARY_DESKTOP_WIDTH = 320;
export const LEFT_COLUMN_WIDTH = 800;
export const SUMMARY_SPACING = 48;
export const MATRIX_CELL_HEIGHT = 115;
export const RATE_CELL_WIDTH = 215;
export const RATE_HEADER_CELL_HEIGHT = 104;
export const EMPTY_CELL_HEIGHT = 70;
export const SCREEN_MAX_WIDTH = 1920;
export const DESKTOP_NUMBER_OF_MONTHS = 3;
export const CLIENT_ID = 'customPrice';

export const TIME_TO_RESERVATION_START_MARK = 'time-to-reservation-start';
export const TIME_TO_RESERVATION_END_MARK = 'time-to-reservation-end';
export const NEW_RESERVATION_SCREEN_EVENT_CATEGORY = 'new-reservation-screen';
export const NRS_LOAD_END_MARK = 'nrs-load-end';
export const TIME_TO_NRS_LOAD = 'time-to-nrs-load';
export const NEW_RESERVATION_BUTTON_DATA_TEST_ID = 'CreateReservation';
